import React from 'react';

/**
 * For testing error reporting in production like environments
 * This is mounted on /admin/_frontend_error
 */
export default function FrontendError() {
  throw new Error('frontend-error-test');

  return (
    <div>Should never get here</div>
  );
}
